/*
 * @Author: Dzy
 * @Date: 2022-07-18 11:02:42
 * @LastEditors: xiangwenheng
 * @LastEditTime: 2023-02-23 14:05:13
 * @Description: 各类工具函数封装，方便统一引用
 */
import { createVNode } from 'vue'
import dayjs from 'dayjs'
import { QINIU_BASE_URL } from '@Con'

export const checkResult = (res) => {
  return res.code == '200'
}

export const checkResultSports = (res) => {
  return res.status == '200'
}

export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)

    reader.onload = () => resolve(reader.result)

    reader.onerror = (error) => reject(error)
  })
}

export const objToQuerystr = (obj) => {
  let params = []
  for (let key in obj) {
    params.push(`${encodeURI(key)}=${encodeURI(obj[key])}`)
  }
  if (params.length) {
    return `?${params.join('&')}`
  } else {
    return ''
  }
}

/**
 *
 * @export base64转blob
 * @param {*} base64Data Object base64数据
 * @return {*} blob
 */
//base64转blob
export const toBlob = (base64Data) => {
  let byteString = base64Data
  if (base64Data.split(',')[0].indexOf('base64') >= 0) {
    byteString = window.atob(base64Data.split(',')[1]) // base64 解码
  } else {
    byteString = unescape(base64Data.split(',')[1])
  }
  // 获取文件类型
  let mimeString = base64Data.split(';')[0].split(':')[1] // mime类型

  // ArrayBuffer 对象用来表示通用的、固定长度的原始二进制数据缓冲区
  // let arrayBuffer = new ArrayBuffer(byteString.length) // 创建缓冲数组
  // let uintArr = new Uint8Array(arrayBuffer) // 创建视图

  let uintArr = new Uint8Array(byteString.length) // 创建视图

  for (let i = 0; i < byteString.length; i++) {
    uintArr[i] = byteString.charCodeAt(i)
  }
  // 生成blob
  const blob = new Blob([uintArr], {
    type: mimeString
  })
  // 使用 Blob 创建一个指向类型化数组的URL, URL.createObjectURL是new Blob文件的方法,可以生成一个普通的url,可以直接使用,比如用在img.src上
  return blob
}

export const blobToFile = (theBlob, fileName) => {
  theBlob.lastModifiedDate = new Date()
  theBlob.name = fileName
  return theBlob
}

export const getImgSize = (file) => {
  return new Promise((resolve) => {
    let img = new Image()
    img.onload = () => {
      resolve([img.width, img.height])
      img.onload = null
      img = null
    }
    img.error = () => {
      resolve(false)
      img.onload = null
      img = null
    }
    getBase64(file).then((imgbase64) => {
      img.src = imgbase64
    })
  })
}

export const jumpThirdSSO = (thirdRoot, appKey, self) => {
  let path = `${thirdRoot}/auth/oauth/authorize?response_type=code&client_id=${appKey}&state=test&redirect_uri=${encodeURI(
    self
  )}`
  window.location.href = path
}

export const downloadFileObj = (data, fileName, dataType = 'blob') => {
  let url
  switch (dataType) {
    case 'arrayBuffer':
      url = window.URL.createObjectURL(new Blob([data], { type: 'arraybuffer' }))
      break
    case 'blob':
      url = window.URL.createObjectURL(new Blob([data]))
      break
    case 'fileUrl':
      url = data
  }
  let dom = document.createElement('a')
  dom.setAttribute('href', url)
  dom.setAttribute('download', fileName)
  dom.click()
}

/**
 * @description: 根据url下载文件并重命名
 * @param {*} url
 * @param {*} fileName
 * @return {*}
 */
export const downloadFile = (url, filename) => {
  /**
   * @description: 根据url获取文件bolb对象
   * @param {*} url
   * @return {*}
   */
  const getBlob = (url) => {
    return new Promise((resolve) => {
      const xhr = new XMLHttpRequest()

      xhr.open('GET', url, true)
      xhr.responseType = 'blob'
      xhr.onload = () => {
        if (xhr.status == 200) {
          resolve(xhr.response)
        }
      }
      xhr.send()
    })
  }

  /**
   * 保存
   * @param  {Blob} blob
   * @param  {String} filename 想要保存的文件名称
   */
  const saveAs = (blob, filename) => {
    if (window.navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename)
    } else {
      const link = document.createElement('a')
      const body = document.querySelector('body')

      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.style.display = 'none'
      body.appendChild(link)

      link.click()
      body.removeChild(link)

      window.URL.revokeObjectURL(link.href)
    }
  }

  try {
    getBlob(url).then((blob) => {
      saveAs(blob, filename)
    })
  } catch (e) {
    throw new Error('下载失败，请联系管理员')
  }
}

export const arrayBufferToStr = (arrayBuffer) => {
  return new Promise((resolve, reject) => {
    const blob = new Blob([arrayBuffer])
    const reader = new FileReader()
    reader.onload = () => {
      resolve(reader.result)
    }
    reader.onerror = (event) => {
      reject(event)
    }
    reader.readAsText(blob, 'utf-8')
  })
}

/**
 * @description:将二进制字符串拆分为特殊十进制数组，例如 '011' => [1,10]
 * @param {*} value // 二进制字符串
 * @param {*} length // 字符串长度
 * @return {*} 数组
 */
export const BinaryToArray = (value, length) => {
  if (!value) return []
  let array = value.split('')
  const result = []
  let tempLength = length
  array.forEach((item) => {
    tempLength--
    if (item !== '0') {
      item = Number(item) * 10 ** tempLength
      result.push(item)
    }
  })
  return result
}

/**
 * @description: 将特殊十进制数组组合为二进制字符串，例如 [10,1] => '011'
 * @param {*} array // 十进制数组
 * @param {*} length // 字符串长度
 * @return {*} 字符串
 */
export const ArrayToBinary = (array, length) => {
  if (array.length == 0) return ''
  let result = 0
  array.forEach((item) => (result += Number(item)))
  result += ''
  if (result.length < length) {
    const tempArray = result.split('')
    for (let i = length - result.length; i > 0; i--) {
      tempArray.unshift('0')
    }
    result = tempArray.join('')
  }
  return result
}

/**
 * @description: 滚动到表单对应item位置
 * @param {*} id 元素id
 * @return {*}
 */
export const scrollToFormErrorByID = (id) => {
  document.getElementById(id).scrollIntoView({ behavior: 'smooth' })
}

/*
 *@param  需要遍历的数组
 *@param  查询所需要的id
 *@param  查询所需要的字段
 */
export const getObjById = (list, id, field = 'value') => {
  //判断list是否是数组
  if (!Array.isArray(list)) {
    return null
  }
  //遍历数组
  for (let i in list) {
    let item = list[i]
    if (item[field] == id) {
      return item
    } else {
      //查不到继续遍历
      if (item.children) {
        let value = getObjById(item.children, id, field)
        //查询到直接返回
        if (value) {
          return value
        }
      }
    }
  }
}

/**
 * @description: 获得数组所有叶子节点
 * @param {*} array 数组
 * @param {*} field 子数组字段
 * @return {*}
 */
export const getAllLeaf = (tree, field = 'children') => {
  const result = []
  const getLeaf = (tree) => {
    tree.forEach((item) => {
      if (!item[field] || !item[field].length) {
        result.push(item)
      } else {
        getLeaf(item[field])
      }
    })
  }
  getLeaf(tree)
  return result
}

/**
 * @description: Minio上传的临时地址 转为 存储相对路径地址
 * @param {*} previewPath 临时地址
 * @return {*}
 */
export const previewToStore = (previewPath) => {
  if (!previewPath.includes(QINIU_BASE_URL)) return previewPath
  const relativePathList = previewPath.split('?')[0].split('/')

  let relativePath = ''
  relativePathList.forEach((path, index) => {
    if (index >= 3) relativePath += '/' + path
  })

  if (relativePath[0] === '/') relativePath = relativePath.slice(1)

  return relativePath
}

/**
 * @description: 创建图标虚拟节点
 * @param {*} className 图标类名
 * @return {*}
 */
export const createConfirmNode = (className) => {
  return createVNode(
    'svg',
    {
      class: 'icon',
      'aria-hidden': 'true'
    },
    [createVNode('use', { 'xlink:href': '#icon-' + className })]
  )
}

/**
 * @description: 数组去掉重复项
 * @param {*} arr
 * @param {*} uniId
 * @return {*}
 */
export const recheckingArray = (arr, uniId) => {
  const res = new Map()
  return arr.filter((item) => !res.has(item[uniId]) && res.set(item[uniId], 1))
}

/**
 * @description: 将接收到的多选框数据字符串（逗号分隔）转换为对应的数组展示字段
 * @param {*} dataString 多选框数据字符串（逗号分隔）
 * @param {*} codeTable 转换数据码表
 * @return {*}
 */
export const identifyMultipleData = (dataString, codeTable) => {
  const tempObj = {}

  codeTable.forEach((item) => {
    tempObj[item.value] = item.label
  })

  const tempArray = []

  dataString.split(',').forEach((key) => {
    if (tempObj[key]) {
      tempArray.push(tempObj[key])
    }
  })

  return tempArray
}

/**
 * @description: 枚举列表转换函数，将 data枚举值 对应的枚举中文字段转译并返回
 * @param {*} data 枚举值
 * @param {*} codeTable
 * @return {*}
 */
export const identifySingeData = (data, codeTable) => {
  const findData = codeTable.find((item) => item.value == data)

  return findData ? findData.label : '\\'
}

/**
 * @description: 将要发送的多选框数据（十进制）转换为对应二进制数据再转为十进制存储
 * @param {*} array 多选框数据数组（十进制）
 * @return {*}
 */
export const sendMultipleData = (array) => {
  let sendData = 0
  array.forEach((item) => {
    sendData += (1 << (item - 1)).toString(2) / 1
  })
  return parseInt(sendData, 2)
}

// 比赛记录格式化时间，将 1h5m6s 转换为 65'6''00
export const formatTimeCompleteMin = (time) => {
  const completeMin = dayjs(time).format(`mm′ss″`).split('′')
  return completeMin[0] / 1 + parseInt(time / 3600000) * 60 + '′' + completeMin[1]
}

// 脱敏，首位和尾星不变，其他*
export const desensitization = (data) => {
  return data[0] + '*'.repeat(data.length - 2) + data[data.length - 1]
}

export const clearStorage = () => {
  localStorage.removeItem('authBusi')
  localStorage.removeItem('userTokenBusi')
  const keys = document.cookie.match(/[^ =;]+(?=\=)/g)
  if (keys) {
    for (let i = keys.length; i--;) {
      document.cookie = keys[i] + '=0;path=/;max-age=0' //清除当前域名下的,例如：m.kevis.com
    }
  }
  // 退出登录保持语言选项，不清缓存
  // sessionStorage.clear()
}

/**
 * @description: 压缩图片
 * @param {*} file 图片文件
 * @return {*}
 */
export const getImgZip = (file) => {
  return new Promise((resolve) => {
    // 压缩图片需要的一些元素和对象
    const reader = new FileReader()
    const img = new Image()
    // 缩放图片需要的canvas
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')

    // 文件base64化，以便获知图片原始尺寸
    reader.onload = function (e) {
      img.src = e.target.result
      img.onerror = () => {
        console.log(`图片已损坏`)
        resolve(null)
      }
    }

    // 选择的文件是图片
    if (file.type.indexOf('image') == 0) {
      reader.readAsDataURL(file)
    }

    // base64地址图片加载完毕后
    img.onload = function () {
      // 图片原始尺寸
      const originWidth = this.width
      const originHeight = this.height
      // 最大尺寸限制
      const maxWidth = (originWidth % 100) + 260
      const maxHeight = (originHeight % 100) + 260
      // 目标尺寸
      let targetWidth = originWidth
      let targetHeight = originHeight
      // 图片尺寸超过 100k 限制
      if (file.size > 1024 * 100) {
        if (originWidth / originHeight > maxWidth / maxHeight) {
          // 更宽，按照宽度限定尺寸
          targetWidth = maxWidth
          targetHeight = Math.round(maxWidth * (originHeight / originWidth))
        } else {
          targetHeight = maxHeight
          targetWidth = Math.round(maxHeight * (originWidth / originHeight))
        }
      }

      // canvas对图片进行缩放
      canvas.width = targetWidth
      canvas.height = targetHeight
      // 清除画布
      context.clearRect(0, 0, targetWidth, targetHeight)
      // 图片压缩
      context.drawImage(img, 0, 0, targetWidth, targetHeight)
      // canvas转为blob并上传
      canvas.toBlob(function (blob) {
        let newZipFile = new window.File([blob], file.name, {
          type: file.type
        })
        resolve(newZipFile)
      }, file.type || 'image/png')
    }
  })
}

export const arrayToTree = (array, pidFleid = 'pid', idFleid = 'id') => {
  const obj = {}
  array.forEach((item) => {
    obj[item[idFleid]] = item
  })

  const result = []
  array.forEach((item) => {
    const parent = obj[item[pidFleid]]
    if (parent) {
      // * 当前项有父节点
      parent.children = parent.children || []
      parent.children.push(item)
    } else {
      // * 当前项没有父节点 -> 顶层
      result.push(item)
    }
  })
  return result
}
